import { number, t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
/** Text-bearing marketing screenshots are rendered as live UI in Persian. */
export const LocalizedProductPreview = ({
  title,
  compact = false,
}: {
  title: string;
  compact?: boolean;
}) => {
  useLocale();
  return (
    <div
      className="flex h-full min-h-56 w-full flex-col gap-4 overflow-hidden rounded-xl border border-[#deddf0] bg-[#f8f7fc] p-5 text-[#28338b] shadow-sm"
      dir="rtl"
    >
      <div className="flex items-center justify-between border-[#deddf0] border-b pb-3">
        <strong>Raven</strong>
        <span className="text-xs">{t('workspace.dashboard')}</span>
      </div>
      <h4 className="font-semibold text-base">{title}</h4>
      {!compact && (
        <div className="grid grid-cols-3 gap-2">
          {[t('auth.clients'), t('workspace.reports'), t('reports.pending')].map((label, index) => (
            <div className="rounded-lg bg-white p-3" key={label}>
              <div className="text-xs">{label}</div>
              <strong className="text-xl">{number([24, 38, 6][index]!)}</strong>
            </div>
          ))}
        </div>
      )}
      <div className="space-y-3 rounded-lg bg-white p-3 text-xs">
        <div className="flex justify-between border-b pb-2">
          <span>{t('reports.clientName')}</span>
          <span>{t('reports.status')}</span>
        </div>
        {[t('reports.individual'), t('reports.business')].map((label) => (
          <div className="flex items-center justify-between gap-3" key={label}>
            <span>{label}</span>
            <span className="rounded-full bg-[#e8e5f5] px-2 py-1">
              {t('reports.pendingReview')}
            </span>
          </div>
        ))}
      </div>
      <div aria-hidden="true" className="flex items-end gap-3">
        {[35, 60, 45, 80, 55, 95].map((height, index) => (
          <div className="flex-1 rounded-t bg-[#9a94cf]" key={index} style={{ height }} />
        ))}
      </div>
    </div>
  );
};
